export const allPaths = {
  home: "/",
  recipes: "/recipes",
  meal_planner: "/meal_planner",
  grocery_lists: "/grocery_lists",
  nutrition_tracker: "/nutrition_tracker",
};
